import React from "react";
import { Icon, IconButton, Popover, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import { app_path } from "config";
const StyledTypography = styled(Typography.H3).attrs()`
  white-space: nowrap;
  color: ${(props) => props.theme.palette.dark.c200};
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  &:hover {
    color: ${(props) => props.theme.palette.dark.c300};
  }
`;

const CustomPopoverHoverBackground = styled(Typography).attrs()`
 .eui-option-inner{
  padding-top:12px ;
  padding-bottom:12px ;
 }
 .eui-option-inner:hover{
    background-color: ${(props) => props.theme.palette.light.c100};
},`;

const FestiveGifting = ({ currency = "INR", typeformParams = "" }) => {
  const isINRClient = currency === "INR";

  let options = [];

  // isINRClient && options.push({
  //   title: "Diwali Gifting",
  //   subtitle: "Send gifts for occasion of Diwali",
  //   link: `/${app_path}/holiday-gifting/`,
  //   disabled: false,
  // })
  // isINRClient && options.push({
  //   title: "Christmas Gifts",
  //   subtitle: "Coming Soon",
  //   link: "",
  //   disabled: true,
  // })
  // isINRClient && options.push({
  //   title: "New Year Gifts",
  //   subtitle: "Coming Soon",
  //   link: "",
  //   disabled: true,
  // })

  // if (!isINRClient) {
  //   options.push([{
  //     title: "Holiday Gifts",
  //     subtitle: "Share holiday magic",
  //     link: "https://survey.typeform.com/to/tSkHciiU",
  //     display: !isINRClient,
  //     disabled: false,
  //   }])
  // }

  return (
    <></>
    // <div className="mr-60">
    //   {options.length > 0 ? <Popover
    //     trigger="hover"
    //     onOverlayClick={() => {}}
    //     onVisibilityChange={function noRefCheck() {}}
    //     content={
    //       <CustomPopoverHoverBackground className="mb-0">
    //         {options.map((option) =>
    //             <Popover.Options key={option?.title}>
    //               <a
    //                 href={option.link}
    //                 target="_blank"
    //                 className="d-flex justify-content-between"
    //                 rel="noreferrer"
    //                 style={{
    //                   pointerEvents: option.disabled ? "none" : "auto",
    //                 }}
    //               >
    //                 <Typography component="span" className="ml-12">
    //                   <Typography
    //                     component="div"
    //                     color="dark"
    //                     shade={option.disabled ? "c100" : "c300"}
    //                     className="whitespace-nowrap text-left"
    //                   >
    //                     {option.title}
    //                   </Typography>
    //                   <Typography.BodySmall
    //                     color="dark"
    //                     shade={option.disabled ? "c100" : "c200"}
    //                     className="mb-0 text-left"
    //                   >
    //                     {option.subtitle}
    //                   </Typography.BodySmall>
    //                 </Typography>
    //               </a>
    //             </Popover.Options>
    //         )}
    //       </CustomPopoverHoverBackground>
    //     }
    //     placement="bottom-end"
    //     offset={[100, 0]}
    //     width={312}
    //   >
    //     <Typography.LabelText
    //       id={`festive-reward-title`}
    //       className="cursor-pointer"
    //       color="dark"
    //       shade="c200"
    //       component="div"
    //     >
    //       Festive Gifting
    //       <Typography.BodySmall
    //         color="green"
    //         shade="c300"
    //         className="position-absolute ml-4"
    //         style={{ top: "7px" }}
    //         component="span"
    //       >
    //         New
    //       </Typography.BodySmall>
    //     </Typography.LabelText>
    //   </Popover> : null}
    // </div>
  );
};

export default FestiveGifting;
